"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _core = require("@material-ui/core");
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useStyles = (0, _styles.makeStyles)(theme => (0, _styles.createStyles)({
  formControl: {
    'margin': '0 8px',
    '& div.MuiInputBase-root': {
      backgroundColor: _episourceColor["default"].textContrast,
      color: _episourceColor["default"].iconDefault
    },
    '& label.MuiFormLabel-root.Mui-focused': {
      color: _episourceColor["default"].iconHover
    }
  },
  inputLabel: {
    color: _episourceColor["default"].iconDefault
  },
  iconButton: {
    'backgroundColor': _episourceColor["default"].iconDefault,
    'margin': '0 8px',
    'color': theme.palette.common.white,
    '&:hover': {
      backgroundColor: _episourceColor["default"].iconHover
    }
  },
  iconHover: {
    border: "solid 2px black"
  }
}));
const ClientPicker = _ref => {
  var _selectedClient$busin;
  let {
    clients = [],
    selectedClient,
    onChange,
    onCancel,
    clientPickerText,
    selectedLineOfBusiness,
    enableClientPicker
  } = _ref;
  const classes = useStyles({});
  const identifyBusinessLines = clientId => {
    var _find;
    return ((_find = (0, _lodash.find)(clients, {
      id: clientId
    })) === null || _find === void 0 ? void 0 : _find.businessLines) || [{}];
  };
  const mapMedicaidStates = clientId => {
    const businessLines = identifyBusinessLines(clientId);
    return businessLines.filter(lob => lob.name === 'medicaid').map(l => ({
      id: l.id,
      state: l.state
    })) || [{}];
  };
  const [selectedClientId, setSelectedClientId] = (0, _react.useState)(selectedClient ? selectedClient.id : '');
  const [newSelectedClient, setNewSelectedClient] = (0, _react.useState)(selectedClient);
  const [newBusinessLine, setNewBusinessLine] = (0, _react.useState)(selectedLineOfBusiness);
  const [medicaidStates, setMedicaidStates] = (0, _react.useState)(mapMedicaidStates(selectedClientId) || [{}]);
  const [activeBusinessLines, setActiveBusinessLines] = (0, _react.useState)(() => identifyBusinessLines(selectedClientId));
  (0, _react.useEffect)(() => {
    const states = mapMedicaidStates(selectedClientId);
    setMedicaidStates(states);
    setActiveBusinessLines(() => identifyBusinessLines(selectedClientId));
  }, [selectedClientId]);
  const onClientSelect = (event, value) => {
    // Bail if the user didn't make a selection, this can happen when the search
    // is cleared.
    if (!(value !== null && value !== void 0 && value.id)) {
      return;
    }
    const clientId = Number(value.id);
    const states = mapMedicaidStates(clientId);
    if (clientId !== selectedClientId) {
      const businessLines = identifyBusinessLines(clientId);
      setActiveBusinessLines(businessLines);
      setNewBusinessLine(() => (0, _lodash.find)(businessLines, l => l.name === (newBusinessLine === null || newBusinessLine === void 0 ? void 0 : newBusinessLine.name)) || (0, _lodash.first)(businessLines));
    }
    setNewSelectedClient(value);
    setSelectedClientId(clientId);
    setMedicaidStates(states);
  };
  const onBusinessLineSelect = event => {
    setNewBusinessLine(() => (0, _lodash.find)(activeBusinessLines, l => l.id === parseInt(event.target.value, 10)));
  };
  const onStateSelect = event => {
    setNewBusinessLine(() => (0, _lodash.find)(activeBusinessLines, l => l.id === parseInt(event.target.value, 10)));
  };
  const activeOptions = () => {
    const medicareOpt = (newBusinessLine === null || newBusinessLine === void 0 ? void 0 : newBusinessLine.name) === 'medicare' ? newBusinessLine : (0, _lodash.find)(activeBusinessLines, {
      name: 'medicare'
    });
    const medicaidOpt = (newBusinessLine === null || newBusinessLine === void 0 ? void 0 : newBusinessLine.name) === 'medicaid' ? newBusinessLine : (0, _lodash.find)(activeBusinessLines, {
      name: 'medicaid'
    });
    const options = [];
    if (medicareOpt) {
      options.push(medicareOpt);
    }
    if (medicaidOpt) {
      options.push(medicaidOpt);
    }
    return options;
  };
  const onSave = () => {
    if (typeof onChange !== 'undefined') {
      onChange((0, _lodash.find)(clients, {
        id: selectedClientId
      }), newBusinessLine);
    }
  };
  const onClose = () => {
    setSelectedClientId(selectedClient ? selectedClient.id : '');
    setNewBusinessLine({});
    if (typeof onCancel !== 'undefined') {
      onCancel();
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-cy": "clientPicker"
  }, enableClientPicker && /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    variant: "filled",
    className: classes.formControl
  }, /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    clearOnEscape: true,
    options: clients,
    getOptionLabel: option => {
      var _option$name;
      return (_option$name = option === null || option === void 0 ? void 0 : option.name) !== null && _option$name !== void 0 ? _option$name : '';
    },
    style: {
      width: 320
    },
    value: newSelectedClient,
    onChange: onClientSelect,
    renderInput: params => /*#__PURE__*/_react["default"].createElement(_core.TextField, (0, _extends2["default"])({}, params, {
      label: clientPickerText || 'Client',
      variant: "filled",
      InputLabelProps: {
        className: classes.inputLabel
      }
    }))
  })), (activeBusinessLines === null || activeBusinessLines === void 0 ? void 0 : activeBusinessLines.length) && /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    variant: "filled",
    className: classes.formControl
  }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    className: classes.inputLabel
  }, "Line of Business"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    value: newBusinessLine === null || newBusinessLine === void 0 ? void 0 : newBusinessLine.id,
    onChange: onBusinessLineSelect,
    style: {
      minWidth: '160px'
    },
    autoWidth: true,
    "data-cy": "clientLineOfBusiness",
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    }
  }, activeOptions().map(lob => /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    key: lob.id,
    value: lob.id,
    "data-cy": lob.name
  }, (0, _lodash.capitalize)(lob.name))))), (newBusinessLine === null || newBusinessLine === void 0 ? void 0 : newBusinessLine.name) === 'medicaid' && (selectedClient === null || selectedClient === void 0 ? void 0 : (_selectedClient$busin = selectedClient.businessLines) === null || _selectedClient$busin === void 0 ? void 0 : _selectedClient$busin.length) && /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    variant: "filled",
    className: classes.formControl
  }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    className: classes.inputLabel
  }, "State"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    value: newBusinessLine.id || (medicaidStates === null || medicaidStates === void 0 ? void 0 : medicaidStates[0].id),
    onChange: onStateSelect,
    autoWidth: true,
    "data-cy": "clientState",
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    }
  }, medicaidStates === null || medicaidStates === void 0 ? void 0 : medicaidStates.map(mo => /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    key: mo.id,
    value: mo.id,
    "data-cy": mo.state
  }, mo.state)))), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "save",
    onClick: onSave,
    className: classes.iconButton,
    "data-cy": "clientPickerSave"
  }, /*#__PURE__*/_react["default"].createElement(_Check["default"], null)), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "cancel",
    onClick: onClose,
    className: classes.iconButton,
    "data-cy": "clientPickerClose"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)));
};
var _default = ClientPicker;
exports["default"] = _default;